import React from 'react';
import _ from 'lodash';
import { reduxForm } from 'redux-form';
import denormalize from 'json-api-denormalizer';
import { connect } from 'react-redux';
import * as actions from './actions';
import GenericForm from '../../components/GenericForm';
import AsyncElements from '../../components/AsyncElements';
import ImageHeader from '../../components/ImageHeader';
import StudentGroupingsContainer from '../StudentGroupingsContainer/index';
import headerImage from '../../assets/img/banners/Manage_Classes_Cover.jpg';
import validate from './validate';
import asyncValidate from './asyncValidate';

class StudentFormContainer extends React.Component {
  componentDidMount(){ this.fetchStudents() }

  fetchStudents = ()=> {
    const { dispatch } = this.props
    actions.fetchStudents(dispatch)
  }

  onSubmitNew = e=>{
    const { dispatch, formData } = this.props
    e.preventDefault();
    if(_.isEmpty(formData.student.profile_attributes)) { delete formData.student.profile_attributes }
    dispatch(actions.submitNewStudent(formData))
  }

  userIsLoggedIn = ()=>!_.isEmpty(this.props.currentUser)

  onSuccess = ()=>{}

  additionalComponentProps = ()=>({
    additionalComponentProps: {
      usernameError: this.props.usernameError,
      studentIsLoggedIn: !_.isEmpty(this.props.currentUser),
      isAsyncValidating: this.props.isAsyncValidating,
      sections: this.props.sections,
      courses: this.props.courses,
      currentUser: this.props.currentUser
    }
  })

  renderRegistrationPage = ()=><GenericForm {...this.props} {...this.additionalComponentProps()} onSuccess={this.onSuccess} onSubmitNew={this.onSubmitNew} />

  render() {
    if(this.userIsLoggedIn()) {
      return(
        <ImageHeader image={headerImage} titleContents='Registration' subtitleText='register for class' containerSection='student-registration-container'>
          <AsyncElements isLoading={this.props.isFetching} fetchError={this.props.fetchError}>
            {this.renderRegistrationPage()}
          </AsyncElements>
        </ImageHeader>
      );
    } else {
      return(
        <ImageHeader image={headerImage} titleContents='Registration' subtitleText='register for class' containerSection='student-registration-container'>
          {this.renderRegistrationPage()}
        </ImageHeader>
      );
    }
  }
}

const mapStateToProps = state => {
  const currentUser = (state.currentUser || {}).data
  const studentIsLoggedIn = !_.isEmpty(currentUser)
  let defaultStudentFormValues;
  if(studentIsLoggedIn) {
    defaultStudentFormValues = { student: { profile_attributes: {}, user_uuid: currentUser.uuid } }
  } else {
    defaultStudentFormValues = { student: { profile_attributes: {} } }
  }
  const formData = (state.form.studentForm || {}).values
  const usernameError = _.isEmpty(formData) ? '' : (((state.form.studentForm.asyncErrors || {}).student || {}).profile_attributes || {}).username
  const sections = denormalize(state.api).sections || {}
  const courses = denormalize(state.api).courses || {}

  return({
    formData,
    usernameError,
    isAsyncValidating: (state.form.studentForm || {}).asyncValidating,
    initialValues: defaultStudentFormValues,
    currentUser,
    sections,
    courses,
    isFetchingInstructors:  state.studentGroupings.isFetching,
    fetchInstructorsError:  state.studentGroupings.fetchError,
    ...state.studentForm
  });
}

StudentFormContainer = reduxForm({
  form: 'studentForm',
  validate,
  asyncValidate,
  asyncBlurFields: ['student[registration_code]', 'student[profile_attributes][username]']
})(StudentFormContainer);
export default connect(mapStateToProps)(StudentFormContainer);
